import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { LoadingSpinner } from '../../components'
import { getClientTokenResetPassword } from '../../utils/getClientToken'

type Props = {
  location: {
    search: string
  }
}

export default function BrowseResetPassword({ location: { search } }: Props): JSX.Element {
  const history = useHistory()

  useEffect(() => {
    ;(async () => {
      const params = new URLSearchParams(search)
      const error = params.get('success') === 'false'
      if (error) {
        const errorDescription = params.get('message') || ''
        history.replace(
          `/sso/browse/callback/error?error_description=${encodeURIComponent(errorDescription)}`,
        )
      } else {
        const redirectUrl = params.get('redirect_url') || window.location.origin
        const clientToken = params.get('data')
        if (clientToken) await getClientTokenResetPassword(clientToken)
        window.location.replace(redirectUrl)
      }
    })()
  }, [])

  return (
    <div data-test="browse-reset-password">
      <LoadingSpinner />
    </div>
  )
}
